import { createSelector } from 'reselect';
import BalanceOnHandExpectedInfoColumns from '../../containers/BalanceOnHandExpectedInfoColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.VIEW_BOH_EXPECTED_INFO.isLoading;
export const getData = TableDefinitions.VIEW_BOH_EXPECTED_INFO.getDataFunction();
export const getColumns = createSelector(getData, BalanceOnHandExpectedInfoColumns);
